import PropTypes from 'prop-types';

export const propTypes = {
	acceptLabel: PropTypes.string.isRequired,
	declineLabel: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
};
